function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M3.97548 9.26865C4.20109 8.63695 4.98724 8.38592 5.59626 8.66708C6.24552 8.96682 7.10229 9.25436 8 9.25436C8.89771 9.25436 9.75448 8.96682 10.4037 8.66708C11.0128 8.38592 11.7989 8.63695 12.0245 9.26865L12.5227 10.6637C12.7553 11.3149 12.2725 12 11.581 12H4.419C3.72747 12 3.24468 11.3149 3.47726 10.6637L3.97548 9.26865Z",
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 8,
  cy: 5,
  r: 3,
  fill: "currentColor"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M4.79998 1.59998H1.59998V4.79998",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M4.79998 14.4H1.59998V11.2",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinejoin: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M11.2 1.59998H14.4V4.79998",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinejoin: "round"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M11.2 14.4H14.4V11.2",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinejoin: "round"
});

var SvgId = function SvgId(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgId, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ID.d15bb76b.svg";
export { ForwardRef as ReactComponent };